import React from 'react';
import PageWrapper from '../components/PageWrapper';

const Impressum = () => {
  return (
    <PageWrapper className="py-16 bg-white">
      <div className="max-w-3xl mx-auto px-4">
        <h1 className="text-4xl font-bold text-blue-900 mb-8">Impressum</h1>
        <div className="prose prose-slate max-w-none text-slate-600">
          
          <h2 className="text-xl font-bold text-slate-800 mt-6 mb-2">Angaben gemäß § 5 TMG</h2>
          <p className="mb-4">
            Nordblick Recruiting<br />
            Inhaber: Isaq Amini<br />
            Barmbeker Str. 9a<br />
            22303 Hamburg<br />
            Deutschland
          </p>

          <p className="mb-4">
            Telefon: 0160 5074 395<br />
            E-Mail: info@nordblick-recruiting.de
          </p>

          <h2 className="text-xl font-bold text-slate-800 mt-6 mb-2">Unternehmensform</h2>
          <p className="mb-4">Einzelunternehmen</p>

          <h2 className="text-xl font-bold text-slate-800 mt-6 mb-2">Vertreten durch</h2>
          <p className="mb-4">Isaq Amini</p>

          <h2 className="text-xl font-bold text-slate-800 mt-6 mb-2">Gewerbeanmeldung</h2>
          <p className="mb-4">Gewerbeanmeldung nach deutschem Recht in Hamburg.</p>

          <h2 className="text-xl font-bold text-slate-800 mt-6 mb-2">Umsatzsteuer-ID</h2>
          <p className="mb-4">
            Umsatzsteuer-Identifikationsnummer gemäß § 27a Umsatzsteuergesetz:<br />
            Derzeit nicht vorhanden / wird nachgereicht.
          </p>

          <h2 className="text-xl font-bold text-slate-800 mt-6 mb-2">Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV</h2>
          <p className="mb-4">
            Isaq Amini<br />
            Barmbeker Str. 9a<br />
            22303 Hamburg
          </p>

          <h2 className="text-xl font-bold text-slate-800 mt-6 mb-2">Haftung für Inhalte</h2>
          <p className="mb-4">
            Die Inhalte dieser Website wurden mit größtmöglicher Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte übernehmen wir jedoch keine Gewähr.
          </p>

          <h2 className="text-xl font-bold text-slate-800 mt-6 mb-2">Haftung für Links</h2>
          <p className="mb-4">
            Diese Website enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb übernehmen wir für diese fremden Inhalte keine Gewähr.
          </p>

          <h2 className="text-xl font-bold text-slate-800 mt-6 mb-2">Urheberrecht</h2>
          <p className="mb-4">
            Die durch den Seitenbetreiber erstellten Inhalte und Werke auf dieser Website unterliegen dem deutschen Urheberrecht.
          </p>

        </div>
      </div>
    </PageWrapper>
  );
};

export default Impressum;